import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Scheduler from "react-mui-scheduler";
import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Grid,
  IconButton
} from "@mui/material";
import {
  AccessTime as ClockIcon,
  CalendarToday as CalendarIcon,
  Person as UserIcon,
  AccountCircle as UserCircleIcon,
  Close as CloseIcon
} from '@mui/icons-material';
import AppBarComponent from '../../component/appbar';

function DashboardRoomView() {
  const navigate = useNavigate();
  const [state] = useState({
    options: {
      transitionMode: "zoom",
      startWeekOn: "mon",
      defaultMode: "month",
      minWidth: 540,
      maxWidth: 540,
      minHeight: 540,
      maxHeight: 540
    },
    toolbarProps: {
      showSearchBar: true,
      showSwitchModeButtons: true,
      showDatePicker: true
    }
  });

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedEvents, setSelectedEvents] = useState([]);

  const events = [
    {
      id: "event-1",
      label: "Cardiology Consultation",
      groupLabel: "Dr. Sarah Lee",
      user: "Dr. Sarah Lee",
      color: "#f28f6a",
      startHour: "09:00 AM",
      endHour: "10:30 AM",
      date: "2025-01-01",
      createdAt: new Date(),
      createdBy: "Anna Petrova"
    },
    {
      id: "event-2",
      label: "Cardiology Consultation",
      groupLabel: "Dr. Sarah Lee",
      user: "Dr. Sarah Lee",
      color: "#f28f6a",
      startHour: "12:00 AM",
      endHour: "13:30 AM",
      date: "2025-01-01",
      createdAt: new Date(),
      createdBy: "Anna Petrova"
    },
    // Add other events here...
  ];

  const formatDate = (date) => {
    if (!date) return '';
    if (date instanceof Date) {
      return date.toISOString().split('T')[0];
    }
    if (typeof date === 'string' || typeof date === 'number') {
      const parsedDate = new Date(date);
      if (!isNaN(parsedDate)) {
        return parsedDate.toISOString().split('T')[0];
      }
    }
    return '';
  };

  const handleEventClick = (event, item) => {
    const eventsForDay = events.filter(evt => evt.date === item.date);
    setSelectedEvents(eventsForDay);
    setModalOpen(true);
  };

  const EventCard = ({ event }) => (
    <Card
      elevation={3}
      sx={{
        mb: 2,
        borderRadius: 2,
        background: event.color,
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
        '&:hover': {
          boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.3)',
        },
      }}
    >
      <CardHeader
        title={
          <Box display="flex" alignItems="center" gap={1}>
            <Box
              sx={{
                width: 12,
                height: 12,
                borderRadius: '50%',
              }}
            />
            <Typography variant="h6">{event.label}</Typography>
          </Box>
        }
      />
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Box display="flex" alignItems="center" gap={1}>
              <UserIcon color="action" />
              <Typography>{event.user}</Typography>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box display="flex" alignItems="center" gap={1}>
              <ClockIcon color="action" />
              <Typography>{`${event.startHour} - ${event.endHour}`}</Typography>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box display="flex" alignItems="center" gap={1}>
              <CalendarIcon color="action" />
              <Typography>{event.date}</Typography>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box display="flex" alignItems="center" gap={1}>
              <UserCircleIcon color="action" />
              <Typography>{event.createdBy}</Typography>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );

  return (
    <Box>
      <AppBarComponent />
      <Box sx={{ p: 4, margin: '10px' }}>
        <Scheduler
          locale="en"
          events={events}
          legacyStyle={false}
          options={state?.options}
          alertProps={state?.alertProps}
          toolbarProps={state?.toolbarProps}
          onEventsChange={handleEventClick}
          onCellClick={handleEventClick}
          onTaskClick={handleEventClick}
        />

        <Dialog
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          maxWidth="md"
          fullWidth
          sx={{
            '& .MuiDialog-paper': {
              borderRadius: 2,
              boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
              transition: 'transform 0.3s ease-in-out',
              '&:hover': {
                transform: 'scale(1.02)',
              }
            },
          }}
        >
          <DialogTitle sx={{ m: 0, p: 2 }}>

            {selectedEvents.length > 0
              ? `Events for ${new Date(selectedEvents[0].date).toLocaleDateString()}`
              : 'Events'}
            <IconButton
              aria-label="close"
              onClick={() => setModalOpen(false)}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            {selectedEvents.length > 0 ? (
              selectedEvents.map((event) => (
                <EventCard key={event.id} event={event} />
              ))
            ) : (
              <Card sx={{ bgcolor: '#f5f5f5', borderRadius: 3 }}>
                <CardContent>
                  <Typography
                    align="center"
                    color="text.secondary"
                    sx={{
                      py: 3,
                      fontWeight: 'bold',
                      fontSize: 16,
                    }}
                  >
                    No events for this day 🗓️
                  </Typography>
                </CardContent>
              </Card>
            )}
          </DialogContent>
          <DialogActions>
            <Button variant="contained" onClick={() => navigate('/thewonderblueadmin_room/detailevent')}>เพิ่มรายการ</Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Box>
  );
}

export default DashboardRoomView;
